import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';

const useStyles = makeStyles(theme => ({
  root: {
    ...theme.shape.componentSpacing,
  },
  accordion: {
    borderTop: theme.borders.dropDownBorder,
    borderBottom: theme.borders.dropDownBorder,
    '& .MuiExpansionPanelSummary-content': {
      margin: `${theme.spacing(3)} 0`,
      [theme.breakpoints.up('lg')]: {
        margin: `${theme.spacing(5)} 0`,
      },
      '&.Mui-expanded': {
        margin: `${theme.spacing(3)} 0`,
        [theme.breakpoints.up('lg')]: {
          margin: `${theme.spacing(5)} 0`,
        },
      },
    },
    '& .MuiGrid-root': {
      width: '100%',
    },
    '& .MuiExpansionPanelSummary-root': {
      padding: 0,
      minHeight: 'auto',
      '& .MuiExpansionPanelSummary-expandIcon > span': {
        color: theme.mixins.Black(),
      },
    },
    '& .MuiCollapse-container.MuiCollapse-entered': {
      paddingBottom: `${theme.spacing(4)}`,
      [theme.breakpoints.up('lg')]: {
        paddingBottom: `${theme.spacing(7)}`,
      },
    },
    '& .MuiExpansionPanelDetails-root': {
      display: 'block',
      padding: 0,
    },
    '& .MuiPaper-elevation1': {
      boxShadow: 'none',
    },
    '& .MuiIconButton-label': {
      color: theme.mixins.AbuDhabiOrange(),
    },
    '& .MuiSvgIcon-root': {
      maxWidth: theme.spacing(5),
    },
    '& svg': {
      height: theme.spacing(4),
      width: theme.spacing(4),
      [theme.breakpoints.up('lg')]: {
        height: theme.spacing(5),
        width: theme.spacing(5),
      },
    },
  },
  labelContact: {
    color: theme.palette.text.tertiary,
    marginBottom: theme.spacing(1),
  },
  iconWrapper: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('lg')]: {
      flexDirection: 'row',
      '&.MuiGrid-grid-lg-7': {
        paddingTop: 0,
      },
    },
    [theme.breakpoints.down('md')]: {
      marginBottom: 0,
      '& > div > div': {
        transform: 'none',
      },
    },
  },
  iconWithText: {
    alignItems: 'flex-start',
    marginBottom: theme.spacing(1),
    [theme.breakpoints.up('lg')]: {
      marginBottom: theme.spacing(7),
    },
    '&.hightlight-icon': {
      alignItems: 'center',
    },
    '& .MuiAvatar-root': {
      ...theme.mixins.marginRight(pxToRem(14)),
      [theme.breakpoints.up('lg')]: {
        ...theme.mixins.marginRight(pxToRem(20)),
      },
      '& svg': {
        position: 'relative',
        width: theme.spacing(3),
        height: theme.spacing(3),
        [theme.breakpoints.up('lg')]: {
          top: theme.spacing(-0.5),
          width: theme.spacing(4),
          height: theme.spacing(4),
        },
      },
    },
  },
  contactInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'baseline',
    marginBottom: theme.spacing(3),
    [theme.breakpoints.up('lg')]: {
      flexDirection: 'row',
      marginBottom: theme.spacing(5),
    },
    '& a': {
      textDecoration: 'underline',
    },
  },
  contactPerson: {
    [theme.breakpoints.up('lg')]: {
      ...theme.mixins.marginRight(theme.spacing(4)),
    },
  },
  email: {
    color: theme.palette.text.secondary,
    textDecoration: 'none!important',
    [theme.breakpoints.up('lg')]: {
      ...theme.mixins.marginRight(theme.spacing(4)),
      '&:hover': {
        color: theme.palette.primary.main,
        textDecoration: 'underline!important',
      },
    },
  },
  highlightsLabel: {
    paddingBottom: theme.spacing(3),
    [theme.breakpoints.up('lg')]: {
      paddingBottom: '0',
    },
  },
  description: {
    color: theme.palette.text.darkGrey,
    paddingBottom: theme.spacing(4),
    [theme.breakpoints.up('lg')]: {
      paddingBottom: theme.spacing(11),
    },
  },
  facilitiesTable: {
    width: '100%',
    marginTop: theme.spacing(4),
    [theme.breakpoints.up('lg')]: {
      marginTop: '0',
    },
    '& table': {
      margin: '0',
      boxShadow: theme.shadows[1],
      width: '100%',
      '& thead': {
        border: theme.borders.divider,
        [theme.breakpoints.down('md')]: {
          border: 'none',
        },
      },
      '& th': {
        ...theme.typography.body2Bold,
        textAlign: theme.mixins.textLeft(),
        [theme.breakpoints.up('lg')]: {
          '&:first-child': {
            ...theme.mixins.paddingLeft(theme.spacing(5)),
          },
        },
      },
      '& td': {
        ...theme.typography.body2,
        textAlign: theme.mixins.textLeft(),
        [theme.breakpoints.down('md')]: {
          ...theme.mixins.paddingLR('50%', pxToRem(10)),
          '&:before': {
            ...theme.typography.body2Bold,
            ...theme.mixins.left(theme.spacing(4)),
            ...theme.mixins.right('auto'),
            ...theme.mixins.paddingLR(0, pxToRem(10)),
          },
          '&:first-child': {
            ...theme.mixins.paddingLeft(theme.spacing(4), pxToRem(10)),
          },
        },
        '&:first-child': {
          [theme.breakpoints.down('md')]: {
            ...theme.typography.body2Bold,
          },
          [theme.breakpoints.up('lg')]: {
            ...theme.mixins.paddingLeft(theme.spacing(5)),
          },
        },
      },
      '& tbody tr': {
        [theme.breakpoints.down('md')]: {
          border: 'none',
          '&:first-child': {
            borderTop: theme.borders.divider,
          },
        },
      },
    },
  },
}));

export default useStyles;
